import type { GraphQLError } from 'graphql';

export const SUCCESS_RESPONSE_TYPE = 'JiraWorkManagementGiraOverview';

export type ProjectLead = {
	accountId: string;
	name: string;
	picture: string;
} | null;

export type OverviewMetaQueryProject = {
	projectId: string;
	lead?: ProjectLead | null;
};

type OverviewFragmentResponse = {
	projects: {
		edges: {
			node: OverviewMetaQueryProject;
		}[];
	};
};

export type OverviewSuccess = {
	__typename: typeof SUCCESS_RESPONSE_TYPE;
} & OverviewFragmentResponse;

export type OverviewError = { __typename: string } & GraphQLError;

export type OverviewDetailsResponse = {
	data?: {
		jira?: {
			overview?: OverviewSuccess | OverviewError | null;
		} | null;
	} | null;
	errors?: ReadonlyArray<GraphQLError>;
};
